import React from 'react';
import './ConfirmationModal.css';

interface FormModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  /** The form goes here; it brings its own action buttons (no modal footer). */
  children: React.ReactNode;
  /** Widen the dialog for large forms (calendar pickers etc.) */
  wide?: boolean;
}

/**
 * Modal shell for embedding the shared form components (SubscriptionForm,
 * StudentVacationFormBody). Unlike ConfirmationModal it has no footer — the
 * embedded form owns its submit/cancel buttons.
 */
const FormModal: React.FC<FormModalProps> = ({ isOpen, title, onClose, children, wide = false }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={wide ? { maxWidth: '720px', width: '92%' } : undefined}
      >
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body" style={{ maxHeight: '78vh', overflowY: 'auto' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default FormModal;
